import React from "react";
import { OrderSignatureForm } from "../../OrderForms/OrderSignatureForm";
import type { SignatureConfigItem } from "@ifa/utils";

interface SignDocumentViewProps {
  signatureConfig: SignatureConfigItem[];
  activeDocKey: string;
  onActiveDocChange: (key: string) => void;
}

export function SignDocumentView({ signatureConfig, activeDocKey, onActiveDocChange }: SignDocumentViewProps) {
  // 标记所有文档为已读（只读模式）
  const allReadDocs = new Set(signatureConfig.map((doc) => doc.key || doc.formType || doc.type || ""));

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <OrderSignatureForm readOnly={true} documents={signatureConfig} activeDocKey={activeDocKey} onActiveDocChange={onActiveDocChange} readDocs={allReadDocs} onReadDoc={() => {}} />
    </div>
  );
}
